import { WitnessCompanyDetailPage } from '@/features/companies/pages/detail-page/witness-company-detail';

export const WitnessCompanyDetailRoute = () => {
  return <WitnessCompanyDetailPage />;
};
